import { EXTERNAL_LINKS } from './links'

const prettyURLsDisabled = !!process.env.NEXT_PUBLIC_DISABLE_PRETTY_URLS

const normalizeRoute = (baseURL: string, path: string, queryParam: string) =>
	prettyURLsDisabled ? `${baseURL}?${queryParam}=${path}` : `${baseURL}/${path}`

const preservedParams: Array<string> = [
	'networkId',
	'marketName'
]

// Utility function to get current URL parameters
export const getCurrentUrlParams = (): Record<string, string> => {
	if (typeof window === 'undefined') return {}
	
	const urlSearchParams = new URLSearchParams(window.location.search)
	const params: Record<string, string> = {}
	
	// Convert URLSearchParams to a plain object
	urlSearchParams.forEach((value, key) => {
		if (preservedParams.includes(key)) {
			params[key] = value
		}
	})
	
	return params
}

// Modified formatUrl to preserve existing URL parameters
export const formatUrl = (route: string, params: Record<string, string>, preserveParams: boolean = true) => {
	// Get current URL parameters if preserveParams is true
	const currentParams = preserveParams ? getCurrentUrlParams() : {}
	
	// Merge current parameters with new parameters (new params take precedence)
	const mergedParams = { ...currentParams, ...params }
	
	return route + '?' + new URLSearchParams(mergedParams)
}

export enum MarketInfoTab {
	INFO = 'info',
	MARKET_HISTORY = 'market_history',
	MY_ORDERS = 'my_orders',
	MY_HISTORY = 'my_history',
}

export const ROUTES = {
	Home: {
		Root: formatUrl('/', {}, true),
	},
	Dashboard: {
		Home: '/dashboard',
		Overview: formatUrl('/dashboard/overview', {}, true),
		History: formatUrl('/dashboard/history', {}, true),
		Markets: formatUrl('/dashboard/markets', {}, true),
		Earn: formatUrl('/dashboard/earn', {}, true),
		Stake: formatUrl('/dashboard/staking', {}, true),
		Rewards: formatUrl('/dashboard/rewards', {}, true),
		Migrate: formatUrl('/dashboard/migrate', {}, true),
		Redeem: formatUrl('/dashboard/redeem', {}, true),
		TradingRewards: formatUrl('/dashboard/staking', { tab: 'trading-rewards' }, true),
	},
	Manage: {
		Home: formatUrl('/manage/list-token', {}, true),
		ListToken: formatUrl('/manage/list-token', {}, true),
		ListPair: formatUrl('/manage/list-pair', {}, true),
		Custom: formatUrl('/manage/custom', {}, true),
	},
	Markets: {
		Home: (asset: string) =>
			formatUrl('/market', { asset }, true),
		Info: (asset: string) =>
			formatUrl('/market', { asset, tab: MarketInfoTab.INFO }, true),
		MarketHistory: (asset: string) =>
			formatUrl('/market', { asset, tab: MarketInfoTab.MARKET_HISTORY }, true),
		MyOrders: (asset: string) =>
			formatUrl('/market', { asset, tab: MarketInfoTab.MY_ORDERS }, true),
		MyHistory: (asset: string) =>
			formatUrl('/market', { asset, tab: MarketInfoTab.MY_HISTORY }, true),
	},
	Swap: {
		Home: formatUrl('/swap', {}, true),
	},
	Wallet: {
		Home: formatUrl('/wallet', {}, true),
		Asset: (address: string) => formatUrl('/wallet/asset', { address }, true),
	},
	Referrals: {
		Home: '/referrals',
		nftMint: (asset: string, ref: string) => formatUrl('/market', { asset, ref }, true),
	},
	NotFound: {
		Home: '/404'
	},
}

export default ROUTES
